// 调试API
import request from '@/utils/request/sso';

//获取登录配置信息
export function ssoGetConfig(parameter) {
    return request({
        url: '/sso/getConfig',
        method: 'GET',
        params:parameter
    });
}
//登录
export function login(parameter) {
    return request({
        url: '/sso/login',
        method: 'GET',
        params:parameter
    });
}